import React from "react";

import CustomUTMeasurementsOverview from "../custom-utm-overview";
import IsometricDrawing from "../isometric-drawing";

import { CustomUTMOverview, PDFImageProps, UTMInspection } from "../../../../utils/models";
import { getChunkedData, sortTMLReadings } from "../../../../utils/utilities";
import { useAppSelector } from "../../../../store/configureStore";
import { getReportDetails } from "../../../../store/reportDetails";

interface Props {
    title?: string;
    tmlLocations: PDFImageProps[];
    utInspectionItems: UTMInspection[];
    inspectionOverview: CustomUTMOverview;
}

const CustomUTMReportPDF: React.FC<Props> = ({ tmlLocations, utInspectionItems, inspectionOverview, title = 'TML Location' }) => {
    const { itemCountPerPage } = useAppSelector(getReportDetails);
    
    return ( 
        <>
            <IsometricDrawing label={title} isoImages={tmlLocations} />

            {utInspectionItems.map((inspectionItem) => (
                <React.Fragment key={inspectionItem.sectionTitle}>
                    {getChunkedData(sortTMLReadings(inspectionItem.items), itemCountPerPage).map((chunkedData, index) => (
                        <CustomUTMeasurementsOverview
                            key={index}
                            summary=''
                            includeSize={false}
                            readingStartColumn={inspectionItem.startColumn}
                            readingEndColumn={inspectionItem.endColumn}
                            sectionSubtitle={inspectionItem.sectionTitle}
                            dateOfUTM={inspectionOverview.dateOfUTM}
                            unit={inspectionOverview.unit}
                            corrosionAllowance={inspectionOverview.corrosionAllowance}
                            data={chunkedData}
                            calibrationDueDate={inspectionOverview.calibrationDueDate}
                            material={inspectionOverview.material}
                            amplitudeLinearityCheck={inspectionOverview.amplitudeLinearityCheck}
                            screenHeightLinearityCheck={inspectionOverview.screenHeightLinearityCheck}
                            scanningLevel={inspectionOverview.scanningLevel}
                            ndeTechnique={inspectionOverview.ndeTechnique}
                            equipment={inspectionOverview.equipment}
                            refStd={inspectionOverview.refStd}
                            remarks={inspectionOverview.remarks}
                            probe={inspectionOverview.probe}
                            techniqueType={inspectionOverview.techniqueType}
                            velocity={inspectionOverview.velocity}
                            calibrationBlk={inspectionOverview.calibrationBlk}
                            serialNo={inspectionOverview.serialNo}
                            couplant={inspectionOverview.couplant}
                        />
                    ))}
                </React.Fragment>
            ))}
        </>
     );
};
 
export default CustomUTMReportPDF;